import React from 'react';
import { cn } from '../../lib/utils';

export default function PageShell({ children, className, noPadding = false }) {
  return (
    <div className={cn(
      "max-w-7xl mx-auto animate-in fade-in slide-in-from-bottom-2 duration-700",
      !noPadding && "px-4 py-8 md:px-8",
      className
    )}>
      {children}
    </div>
  );
}
